import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getAuth } from '../../selectors/access/auth'
import { showLoader, hideLoader } from '../../actions/common'
import messageModalActions from '../../actions/modals/messageModal'
import { fetchCombosSuccess } from '../../actions/combos/combos'
import combosActionTypes from '../../constants/actions/combos/combos'
import { handleError } from '../errors/errorManager'
import getColorCombo from '../../services/color/getColorCombo'

export function * fetchColorCombo ({ catalogueId, modelId }) {
  try {
    yield put(showLoader())
    const auth = yield select(getAuth)
    const colorCombo = yield call(getColorCombo, auth.token, catalogueId, modelId)
    yield put(fetchCombosSuccess({ colorCombo }))
  } catch (error) {
    const customHandler = function * () {
      yield put(messageModalActions.openErrorMessageModal('MESSAGES.FETCH_COMBO_ERROR'))
    }
    yield call(handleError, { error, customHandler })
  } finally {
    yield put(hideLoader())
  }
}

export function * watchFetchColorCombo () {
  yield takeLatest(combosActionTypes.FETCH_COLOR_COMBO, fetchColorCombo)
}
